import React, { useEffect, useState } from "react";
import PopupWrapper from "../components/PopupWrapper";
import { Button, Spinner } from "@chakra-ui/react";
import axios from "axios";
import { getAxiosConfig } from "../utils/helpers";
import MyInput from "../components/formComponents/MyInput";
import MyBoolean from "../components/formComponents/MyBoolean";
import { toast } from "react-toastify";
import { set } from "react-hook-form";
import { Icon } from "@iconify/react/dist/iconify.js";
import { IMG_SERVER_URL } from "../utils/constant";
import Img from "../components/Img";

const CollectionsPopup = ({ image, isOpen, onClose }) => {
  const [collections, setCollections] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isNewCollection, setIsNewCollection] = useState([false, ""]);
  const [selectedCollections, setSelectedCollections] = useState([]);

  async function fetchCollections() {
    try {
      const {
        data: { data },
      } = await axios.get(
        `${process.env.REACT_APP_BACK_URL}/api/collection/get-all`,
        getAxiosConfig(),
      );
      setCollections(data);
      // data.forEach((coll) => {
      //   if (coll.images?.some((img) => img?.id == image?._id)) {
      //     setSelectedCollections((prev) => [...prev, coll._id]);
      //   }
      // });
    } catch (error) {
      console.error("Error fetching collections:", error);
    } finally {
      setIsLoading(false);
    }
  }

  async function addNewCollection() {
    try {
      const {
        data: { data },
      } = await axios.post(
        `${process.env.REACT_APP_BACK_URL}/api/collection/create`,
        {
          name: isNewCollection[1],
        },
        getAxiosConfig(),
      );
      toast.success("Canvas created successfully!");
      setCollections((prev) => [...prev, data]);
      setIsNewCollection([false, ""]);
    } catch (error) {
      console.error("Error creating Canvas:", error);
      toast.error("Failed to create Canvas. Please try again.");
    }
  }

  function toggleCollectionSelection(collectionId) {
    setSelectedCollections((prev) => {
      if (prev.includes(collectionId)) {
        return prev.filter((id) => id !== collectionId);
      } else {
        return [...prev, collectionId];
      }
    });
  }

  async function AddImgToCollection() {
    try {
      await Promise.allSettled(
        selectedCollections.map((collecId) =>
          axios.post(
            `${process.env.REACT_APP_BACK_URL}/api/collection/add-images/${collecId}`,
            {
              image: {
                id: image?._id,
                mask: image?.pc,
              },
            },
            getAxiosConfig(),
          ),
        ),
      );

      toast.success("Image added to selected collections successfully!");
      setSelectedCollections([]);
      onClose();
    } catch (error) {
      console.error("Error adding image to collections:", error);
      toast.error("Failed to add image to collections. Please try again.");
    }
  }

  useEffect(() => {
    fetchCollections();
  }, []);
  return (
    <>
      <div>
        <PopupWrapper
          onClose={onClose}
          heading={"Add To Canvas"}
          isShowAction={true}
          width={"max-w-4xl"}
          handleSubmit={() => {
            console.log("Submit action triggered", image);
            AddImgToCollection();
          }}
        >
          <div className="flex items-center justify-end ">
            <Button
              colorScheme="teal"
              onClick={() => setIsNewCollection([true, ""])}
            >
              New Canvas
            </Button>
          </div>
          <div className="h-[60svh] overflow-y-auto my-4 pr-2">
            {isLoading ? (
              <div className="flex justify-center items-center  ">
                <Spinner size={"xl"} colorScheme="teal" />
              </div>
            ) : (
              <div className="h-full">
                {collections.length > 0 ? (
                  <div className="grid grid-cols-4 gap-4 ">
                    {collections.map((collection) => {
                      return (
                        <div
                          onClick={() =>
                            toggleCollectionSelection(collection?._id)
                          }
                          className="h-48 flex flex-col gap-2 relative items-center border border-teal-500 rounded-lg overflow-hidden"
                        >
                          <div className="h-44 w-full">
                            <CollectionCanvas
                              images={collection?.images}
                              step={0}
                            />
                          </div>
                          {collection.name}
                          {selectedCollections?.includes(collection?._id) && (
                            <div className="absolute top-0 left-0 w-full h-full bg-teal-600/40 z-10 flex items-center justify-center ">
                              <Icon
                                icon="mdi:tick-circle"
                                color="white"
                                width={"30px"}
                              />
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="flex items-center justify-center ">
                    <h2>No Canvas Found !!! Create New One</h2>
                  </div>
                )}
              </div>
            )}
          </div>
        </PopupWrapper>
      </div>
      {isNewCollection?.[0] && (
        <PopupWrapper
          handleSubmit={addNewCollection}
          width={"max-w-xl"}
          onClose={() => setIsNewCollection([false, ""])}
          heading={"New Canvas"}
          isShowAction={true}
        >
          <MyInput
            label={"Canvas Name"}
            name={"collectionName"}
            placeholder={"Enter Canvas Name"}
            // required={true}
            value={isNewCollection[1]}
            onChange={(e) => setIsNewCollection([true, e.target.value])}
            size="md"
          />
        </PopupWrapper>
      )}
    </>
  );
};

const CollectionCanvas = ({ images = [], step }) => {
  function getImages(image) {
    if (!image?.id)
      return "https://thumb.ac-illust.com/b1/b170870007dfa419295d949814474ab2_t.jpeg";
    return `${IMG_SERVER_URL}/brick-img/${image.id}.jpg`;
  }

  return (
    <div
      className={`grow overflow-hidden w-full h-full grid ${
        images?.length > 1 ? "grid-cols-2" : "grid-cols-1"
      }  gap-0.5`}
    >
      {/* <Img 
      src={getImages(images[3])}
      className="w-full h-full object-cover "
      width="100%"
      height="100%"
      alt="Collection Image"
      /> */}
      <div
        style={{
          backgroundImage: `url(${getImages(images[0])})`,
          backgroundOrigin: "content-box",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        className={` w-full h-full overflow-hidden  ${
          images?.[2] ? "row-span-1" : "row-span-2"
        }`}
      />
      {images?.[1] && (
        <div
          style={{
            backgroundImage: `url(${getImages(images[1])})`,
            backgroundOrigin: "content-box",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
          className={` w-full h-full overflow-hidden  ${
            images?.[3] ? "row-span-1" : "row-span-2"
          }`}
        />
      )}
      {images?.[2] && (
        <div
          style={{
            backgroundImage: `url(${getImages(images[2])})`,
            backgroundOrigin: "content-box",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
          className=" w-full h-full overflow-hidden "
        />
      )}
      {images?.length > 3 && step <= 1 && (
        <div className=" w-full h-full overflow-hidden ">
          <CollectionCanvas
            images={step + 1 == 2 ? [images?.[3]] : images.slice(3)}
            step={step + 1}
          />
        </div>
      )}
    </div>
  );
};

export default CollectionsPopup;
